import { Component } from "react";

class Delay extends Component {
  static defaultProps = { wait: 250 };

  state = { waiting: true };

  componentDidMount() {
    this.timer = setTimeout(() => {
      this.setState({
        waiting: false
      });
    }, this.props.wait);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render = () => !this.state.waiting && this.props.children;
}

export default Delay;
